<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Abbrechen</button>
  <button mat-raised-button color="warn" (click)="onConfirm()">Bestätigen</button>
</mat-dialog-actions>
